import Vue from "vue";
import Vuex from "vuex";
import SecureLS from "secure-ls";
import * as Cookies from "js-cookie";
import createPersistedState from "vuex-persistedstate";

const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [
		createPersistedState({
			storage: {
				/*getItem: (key) => Cookies.get(key),
				setItem: (key, value) =>
					Cookies.set(key, value, { expires: 3, secure: false }),
				removeItem: (key) => Cookies.remove(key),*/
				getItem: (key) => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: (key) => ls.remove(key)
			},
		}),
	],
	state: {
		back: true,
		event: "",
		unseen_messages: 0,
		message: [],
        toggleAdminView: true,
		jwt: null,
		user: {},
		client: {},
		collapsed: false,
		style: {
			name: {
				menu_title: "Smd",
				menu_title_color: "#FFFFFF",
				menu_title_font: "sans",
				menu_title_size: 1,
			},
			menu: {
				background_color: "#2a2a2e",
				sub_background_color: "#36363b",
				select_background_color: "#4285f4",
				icon_background_color: "#1e1e21",
				select_color: "rgba(30,30,33,.5)",
				sub_select_color: "rgba(30,30,33,.5)",
			},
			theme: {
				background_color: "#F2F4F7",
				text_color: "#181818", // * gris foncé par défaut
				text_color_light: "#F5F5F5", // * gris très clair par défaut
				text_font: "sans",
			},
			tablestyle: {
				header_background_color: "#FFFFFF",
				header_text_color: "#000000",
				cell_background_color: "#FFFFFF",
				cell_text_color: "#000000",
				col_border_thickness: 0,
				row_border_thickness: 0,
				border_color: "#404040",
				// alignement_cellules: "center",
			},
		},
		images_whitelist: null,
		images_blacklist: null,
		videos_whitelist: null,
		videos_blacklist: null,
		categories: null,
		lang: "fr"
	},
    getters: {
		getBack: (state) => state.back,
		getHeart: (state) => state.message,
		getEvent: (state) => state.event,
		getUnseenMessages: (state) => state.unseen_messages,
        getToggleAdminView: state => state.toggleAdminView,
        isUserAdmin: state => {
            return state.user && state.user.rules === null && state.user.details && state.user.details.client_uid !== undefined;
        },
        isAdmin: state => {
            return state.user && state.user.rules === null && state.user.details && state.user.details.client_uid !== undefined;
        },
		getUser: state => { return state.user },
		lang: state => state.lang
    },
	mutations: {
		setLang(state, lang)
		{
			state.lang = lang;
		},
		setCategories(state, categories)
		{
			state.categories = categories;
		},
		setImagesWhitelist(state, whitelist)
		{
			//console.log("store setImagesWhitelist")
			state.images_whitelist = whitelist;
		},
		setImagesBlacklist(state, blacklist)
		{
			//console.log("store setImagesBlacklist")
			state.images_blacklist = blacklist;
		},
		setVideosWhitelist(state, whitelist)
		{
			//console.log("store setVideosWhitelist")
			state.videos_whitelist = whitelist;
		},
		setVideosBlacklist(state, blacklist)
		{
			//console.log("store setVideosBlacklist")
			state.videos_blacklist = blacklist;
		},
		setUnseenMessages: (state, unseen_messages) => state.unseen_messages = unseen_messages,
		setBack: (state, back) => state.back = back,
		setEvent: (state, event) => {
			state.event = event;
		},
		setMessage: (state, message) => state.message = message,
        toggleAdminView(state, toggle) {
            state.toggleAdminView = toggle;
        },
		setCollapsed(state, collapsed) {
			state.collapsed = collapsed;
		},
		setJwt(state, jwt) {
			state.jwt = jwt;
		},
		removeJwt(state) {
			state.jwt = null;
		},
		setUser(state, user) {
			state.user = user;
		},
		removeUser(state) {
			state.user = {};
		},
		setClient(state, client) {
			state.client = client;
		},
		removeClient(state) {
			state.cliient = {};
		},
		setStyle(state, style) {
			state.style = style;
		},
		removeStyle(state) {
			// * il faudrait un get default state ici en base ou quelquechose pour éviter de copier/coller
			state.style = {
				name: {
					menu_title: "Smd",
					menu_title_color: "#FFFFFF",
					menu_title_font: "sans",
					menu_title_size: 1,
				},
				menu: {
					background_color: "#2a2a2e",
					sub_background_color: "#36363b",
					select_background_color: "#4285f4",
					icon_background_color: "#1e1e21",
					select_color: "rgba(30,30,33,.5)",
					sub_select_color: "rgba(30,30,33,.5)",
				},
				theme: {
					background_color: "#F2F4F7",
					text_color: "#181818", // * gris foncé par défaut
					text_color_light: "#F5F5F5", // * gris très clair par défaut
					text_font: "sans",
				},
				tablestyle: {
					header_background_color: "#FFFFFF",
					header_text_color: "#000000",
					cell_background_color: "#FFFFFF",
					cell_text_color: "#000000",
					col_border_thickness: 0,
					row_border_thickness: 0,
					border_color: "#404040",
					// alignement_cellules: "center",
				},
			};
		},
	},
	actions: {},
});
